export default {
  HK: 'hk',
  RQ: 'rq',
  DUMMY: 'dummy',
};



// WEBPACK FOOTER //
// ./src/variables/transportAllotmentTypes.js